import { Service, TeamMember, Testimonial } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const services: Service[] = [
  {
    id: 'pdr-standard',
    title: 'Ausbeulen ohne Lackieren (PDR)',
    description: 'Die sanfte Methode zur Entfernung von Dellen und Beulen unter Erhalt des Originallacks.',
    longDescription: 'Unsere Paintless Dent Repair (PDR) Technik ermöglicht es, Dellen präzise aus dem Blech zu massieren oder zu ziehen, ohne dass eine Neulackierung erforderlich ist. Dies spart Zeit, Kosten und schont die Umwelt.',
    iconName: 'Wrench',
    image: IMAGES.HERO_REPAIR_2,
    benefits: [
      'Erhalt des Originallacks',
      'Keine Farbunterschiede',
      'Kurze Reparaturdauer',
      'Umweltfreundlich da chemiefrei'
    ],
    priceStartingFrom: '80 €'
  },
  {
    id: 'hagelschaden',
    title: 'Hagelschaden-Instandsetzung',
    description: 'Professionelle Beseitigung von Hagelschäden für Privatkunden und Versicherungen.',
    longDescription: 'Nach einem Hagelsturm ist schnelle Hilfe gefragt. Wir begutachten den Schaden und setzen Ihr Fahrzeug mit modernsten Drück- und Klebetechniken wieder instand. Wir unterstützen Sie auch bei der Abwicklung mit Ihrer Versicherung.',
    iconName: 'CloudHail',
    image: IMAGES.TOOLS_WORKSHOP_5,
    benefits: [
      'Direktabrechnung mit Versicherungen',
      'Werterhalt Ihres Fahrzeugs',
      'Hunderte Dellen rückstandslos entfernen',
      'Kostenlose Erstbesichtigung'
    ],
    priceStartingFrom: 'Auf Anfrage'
  },
  {
    id: 'parkschaden',
    title: 'Park- & Türdellen-Service',
    description: 'Schnelle Hilfe bei kleinen Unachtsamkeiten auf dem Parkplatz.',
    longDescription: 'Kleine Dellen durch Einkaufswagen oder fremde Autotüren sind ärgerlich, aber für uns Routine. In den meisten Fällen können wir diese Schäden innerhalb weniger Stunden beheben, während Sie warten.',
    iconName: 'Car',
    image: IMAGES.BEFORE_AFTER_2,
    benefits: [
      'Reparatur oft am selben Tag',
      'Deutlich günstiger als Lackieren',
      'Perfektes Finish',
      'Mobil vor Ort möglich'
    ],
    priceStartingFrom: '60 €'
  },
  {
    id: 'leasing-check',
    title: 'Leasing-Rücknahme-Check',
    description: 'Vermeiden Sie hohe Nachzahlungen bei der Leasingrückgabe durch unseren Vorab-Check.',
    longDescription: 'Bevor Sie Ihr Fahrzeug dem Leasinggeber zurückgeben, prüfen wir es auf optische Mängel. Wir beseitigen Dellen kostengünstig, sodass Sie teure Reparaturkosten des Herstellers vermeiden.',
    iconName: 'CheckCircle',
    image: IMAGES.CAR_DETAIL_3,
    benefits: [
      'Signifikante Kostenersparnis',
      'Professionelle Aufbereitung',
      'Stressfreie Fahrzeugrückgabe',
      'Detailliertes Protokoll'
    ],
    priceStartingFrom: '120 €'
  }
];

export const teamMembers: TeamMember[] = [
  {
    id: 'firat-karabacak',
    name: 'Firat Karabacak',
    role: 'Inhaber & PDR-Spezialist',
    bio: 'Als erfahrener Dellendoktor biete ich professionelle Paintless Dent Repair Services in Bayern und Baden-Württemberg. Mobiler Service vor Ort nach Terminabsprache.',
    image: IMAGES.MECHANIC_WORK_1,
    specialization: 'Ausbeulen ohne Lackieren & Mobile Reparaturen'
  }
];

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: 'Andreas M.',
    rating: 5,
    text: 'Hatte einen fiesen Hagelschaden an meinem BMW. Car dent paintless repair hat ganze Arbeit geleistet. Man sieht absolut nichts mehr! Super Service.',
    date: '2026-01-15',
    vehicleModel: 'BMW M3',
    location: 'München'
  },
  {
    id: 't2',
    name: 'Sabine K.',
    rating: 5,
    text: 'Eine Parkdelle in der Tür wurde innerhalb von 45 Minuten entfernt. Der Preis war absolut fair und das Team sehr freundlich. Sehr zu empfehlen!',
    date: '2025-11-20',
    vehicleModel: 'VW Golf VIII',
    location: 'Stuttgart'
  },
  {
    id: 't3',
    name: 'Michael R.',
    rating: 4,
    text: 'Leasingrückgabe ohne Probleme überstanden dank des Vorab-Checks. Hat mir sicher über 1000 Euro gespart.',
    date: '2026-02-02',
    vehicleModel: 'Audi A6',
    location: 'Berlin'
  }
];

export const companyInfo = {
  name: 'Car dent paintless repair',
  legalName: 'Car dent paintless repair',
  tagline: 'Ausbeulen ohne Lackieren - Mobiler Service vor Ort',
  description: 'Ihr professioneller Dellendoktor für Karosserieinstandsetzung ohne Lackieren. Mobiler Service in Bayern und Baden-Württemberg nach Terminabsprache.',
  owner: 'Firat Karabacak',
  serviceArea: 'Bayern und Baden-Württemberg',
  serviceType: 'Mobiler Service vor Ort nach Terminabsprache',
  email: 'Dellendoktor@tuta.com',
  appointmentUrl: '/kontakt#termin',
  openingHours: {
    monFri: 'Nach Terminabsprache',
    sat: 'Nach Terminabsprache',
    sun: 'Nach Terminabsprache'
  },
  social: {
    whatsapp: 'https://wa.me/message/XXXXXXXXXX'
  },
  establishedYear: 2020,
  copyrightYear: 2026
};